module.exports = __webpack_public_path__ + "static/img/pic4.be2e754.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/specialColumn/pic4.jpg
// module id = +oxe
// module chunks = 0